import React from 'react';
import { Box, Typography, type TypographyKind } from '@saviynt/design-system';

import { CF_SEC_BLD } from '../../constants';
import SodFieldSet from '../SodFieldSet';

interface SodTextFieldSetProps {
  label: string;
  value: string | null | undefined;
  lineLimit?: number;
  kind?: TypographyKind;
  className?: string;
}

/**
 * SodTextFieldSet Component
 *
 * Text field set component for displaying label-value pairs with configurable typography
 * and line limiting capabilities for consistent UI presentation.
 *
 * @component
 * @returns {React.ReactElement} Text field set with label and formatted value display
 *
 * @example
 * <SodTextFieldSet
 *   label="Description"
 *   value="Sample text value"
 *   lineLimit={2}
 *   kind="body2"
 * />
 */
function SodTextFieldSet({
  label,
  value,
  lineLimit = 1,
  kind = 'body2',
  className,
}: SodTextFieldSetProps) {
  return (
    <SodFieldSet
      label={label}
      value={
        <Box
          className={`Sod-TextFieldValue-wrapper${
            className ? ` ${className}` : ''
          }`}>
          <Typography lineLimit={lineLimit} kind={kind} color={CF_SEC_BLD}>
            {value == null ||
            value === '' ||
            (typeof value === 'string' && value.trim() === '')
              ? '-'
              : value}
          </Typography>
        </Box>
      }
    />
  );
}

SodTextFieldSet.defaultProps = {
  lineLimit: 1,
  kind: 'body2',
  className: undefined,
};

export default SodTextFieldSet;
